import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { NationalityActions } from './nationality.actions';
import { NationalityEntity } from './nationality.entity';
import { ObjectNumber } from '../../type';

export const NATIONALITY_FEATURE_KEY = 'nationality';

export interface NationalityState extends EntityState<NationalityEntity> {
  singpassMap: ObjectNumber;
  loaded: boolean; // has the Nationality list been loaded
  error?: string | null; // last known error (if any)
}

export interface NationalityPartialState {
  readonly [NATIONALITY_FEATURE_KEY]: NationalityState;
}

export const nationalityAdapter: EntityAdapter<NationalityEntity> = createEntityAdapter<NationalityEntity>();

export const initialNationalityState: NationalityState = nationalityAdapter.getInitialState({
  singpassMap: {},
  loaded: false,
});

const reducer = createReducer(
  initialNationalityState,
  on(NationalityActions.init, state => ({ ...state, loaded: false, error: null })),
  on(NationalityActions.loadSingpassMap, (state, { singpassMap }) => ({ ...state, singpassMap })),
  on(NationalityActions.loadSuccess, (state, { entities }) =>
    nationalityAdapter.setAll(entities, {
      ...state,
      loaded: true,
    }),
  ),
  on(NationalityActions.loadFailure, (state, { error }) => ({ ...state, error })),
);

export function nationalityReducer(state: NationalityState | undefined, action: Action) {
  return reducer(state, action);
}
